/**
 * The translator, bound to the language this browser is set to.
 *
 * It reads the preference out of the store rather than a module global, so
 * switching the language re-renders everything that shows a string — which is
 * the whole app — without a reload.
 */
import { useMemo } from "react";
import { useStore } from "../state/store";
import { resolveLocale, translate, type Language, type Translate } from "./i18n";

export function useLanguage(): Language {
  return useStore((state) => state.preferences.language);
}

export function useT(): Translate {
  const language = useLanguage();
  return useMemo(() => (key, vars) => translate(language, key, vars), [language]);
}

/** The `Intl` locale that goes with the chosen language. */
export function useLocale(): string {
  return resolveLocale(useLanguage());
}
